import React from 'react';

export function getKeywordPalaceholder(
  formatMessage: (value: string) => string,
) {
  return `${formatMessage(
    'Multiple words are separated by “;” .',
  )}\n${formatMessage('Example：Bug; Issue')}`;
}

export function getKeywordTopicPalaceholder(
  formatMessage: (value: { id: string }, options?: any) => string,
) {
  return (
    <div>
      {formatMessage(
        {
          id: 'Please input the {topic_name} and {topic_definition} here. These two fields are compulsory. Additionally, you may choose to provide some keywords and example sentences related to the topic; these two fields are optional.',
        },
        {
          topic_name: <b>{formatMessage({ id: 'Topic Name' })}</b>,
          topic_definition: <b>{formatMessage({ id: 'Topic Definition' })}</b>,
        },
      )}
      <br />
      {formatMessage(
        {
          id: `When defining a topic, follow the logic of "[{topic_name}] + [{text}] + [{text1}]" to help the system identify more accurately.`,
        },
        {
          topic_name: <b>{formatMessage({ id: 'Topic Name' })}</b>,
          text: <b>{formatMessage({ id: "What it's about. <Exclude> Unwanted Content" })}</b>,
          text1: <b>{formatMessage({ id: 'Real examples/keywords' })}</b>,
        },
      )}
    </div>
  );
}
